const fbTrack = (eventName, params = {}, options = {}) => {
  if (typeof window.fbq !== "function") return;
  if (options.eventID) {
    window.fbq("track", eventName, params, { eventID: options.eventID });
  } else {
    window.fbq("track", eventName, params);
  }
};

export const metaPageView = () => {
  fbTrack("PageView");
};

export const metaPhotoUpload = (photoCount) => {
  if (typeof window.fbq !== "function") return;
  window.fbq("trackCustom", "PhotoUpload", { photo_count: photoCount });
};

export const metaAddToCart = (productName, price) => {
  fbTrack("AddToCart", {
    content_name: productName,
    content_type: "product",
    value: price,
    currency: "RSD",
  });
};

export const metaInitiateCheckout = (totalValue, itemCount) => {
  fbTrack("InitiateCheckout", {
    value: totalValue,
    currency: "RSD",
    num_items: itemCount,
  });
};

export const metaPurchase = (orderNumber, totalValue) => {
  var eventId = "purchase_" + orderNumber;
  fbTrack("Purchase", {
    value: totalValue,
    currency: "RSD",
    content_type: "product",
    order_id: orderNumber,
  }, { eventID: eventId });
};
